// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { useIsPortalSession, useSession } from '@Contexts/session';
import { Navigate } from 'react-router';
import { FrameHome } from './FrameHome';

/** Sends internal sessions to the default landing, which picks a page they may see. */
export function PortalHomeRoute() {
    const isPortalSession = useIsPortalSession();
    const {
        current: { subpath },
    } = useSession();

    if (!isPortalSession) {
        return <Navigate to={`/${subpath}`} replace />;
    }

    return <FrameHome />;
}
